module.exports = __webpack_public_path__ + "static/media/Orchid.9a81c6aa.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/Orchid.jpg
 ** module id = 407
 ** module chunks = 0
 **/